// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"6f093cb8","617":"615dfe95"}[chunkId] + ".chunk.js";
};